import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableJualCustomerPerSurveyor } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader } from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Button,
  ButtonGroup,
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardHeader,
  CardActionArea,
  CardMedia,
  InputAdornment,
  Link,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import { Col, Row, Form } from "react-bootstrap";
import Carousel from "react-elastic-carousel";

const TampilCustomerPerSurveyor = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };
  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "13px",
  };
  const [isFetchError, setIsFetchError] = useState(false);
  // Data Register/Pembeli
  const [namaRegister, setNamaRegister] = useState("");
  const [noKtpRegister, setNoKtpRegister] = useState("");
  const [ketBlacklist, setKetBlacklist] = useState("");
  const [ketPencairan, setKetPencairan] = useState("");
  const [isAccHeadSurveyor, setIsAccHeadSurveyor] = useState(false);

  // Data Penjualan -> dari input
  const [hargaTunai, setHargaTunai] = useState("");
  const [uangMuka, setUangMuka] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");
  const [sisaBulan, setSisaBulan] = useState("");
  const [gambar, setGambar] = useState([]);
  const [gambarBerkas, setGambarBerkas] = useState([]);
  const [isPost, setIsPost] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [jualsData, setJualsData] = useState([]);

  const [value, setValue] = useState("Semua");
  const [valueAcc, setValueAcc] = useState("Semua");
  const [kodeSurveyorFilter, setKodeSurveyorFilter] = useState("");
  const [surveyors, setSurveyors] = useState([]);

  const [error, setError] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  const [pilihCetak, setPilihCetak] = useState("daftarJual");
  const navigate = useNavigate();
  const [isJualData, setIsJualData] = useState(false);
  let isJualExist = id;
  let isEditable = user.tipeUser !== "ADM" && isPost === false;

  const columns = [
    { title: "No. Jual", field: "noJual" },
    { title: "Tanggal Jual", field: "tanggalJual" },
    { title: "Nama Register", field: "namaRegister" },
    { title: "Kode Leasing", field: "kodeLeasing" },
    { title: "Tipe", field: "tipe" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChangeFilter = (event) => {
    setValue(event.target.value);
  };

  const handleChangeFilterAcc = (event) => {
    setValueAcc(event.target.value);
  };

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 3 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 5 },
  ];

  const surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
  }));

  useEffect(() => {
    id && getJualById();
  }, [id]);

  useEffect(() => {
    getSurveyor();
    getJualsData();
  }, [page, searchTerm]);

  const getSurveyor = async () => {
    // setLoading(true);
    if (user.tipeUser === "HEADSURVEYOR") {
      const allSurveyors = await axios.post(
        `${tempUrl}/surveyorsByKodeHeadSurveyor`,
        {
          kodeHeadSurveyor: user.kodeHeadSurveyor,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
      setSurveyors(allSurveyors.data);
    } else {
      const allSurveyors = await axios.post(`${tempUrl}/surveyorsAllCabang`, {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setSurveyors(allSurveyors.data);
    }
    // setLoading(false);
  };

  const getJualsData = async () => {
    setLoading(true);
    try {
      let allJuals;
      if (user.tipeUser === "HEADSURVEYOR") {
        allJuals = await axios.post(
          `${tempUrl}/jualsCustomerPerSurveyorKodeSurveyorPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            status: value,
            statusAcc: valueAcc,
            kodeHeadSurveyor: user.kodeHeadSurveyor,
            dariTgl: user.periode.periodeAwal,
            sampaiTgl: user.periode.periodeAkhir,
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          }
        );
        setQuery(searchTerm);
        setJualsData(allJuals.data.juals);
        setPage(allJuals.data.page);
        setPages(allJuals.data.totalPage);
        setRows(allJuals.data.totalRows);
      } else {
        allJuals = await axios.post(
          `${tempUrl}/jualsCustomerPerSurveyorPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            status: value,
            statusAcc: valueAcc,
            kodeSurveyor: kodeSurveyorFilter.split(" -", 1)[0],
            dariTgl: user.periode.periodeAwal,
            sampaiTgl: user.periode.periodeAkhir,
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          }
        );
        setQuery(searchTerm);
        setJualsData(allJuals.data.juals);
        setPage(allJuals.data.page);
        setPages(allJuals.data.totalPage);
        setRows(allJuals.data.totalRows);
      }
      setLoading(false);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getJualById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/juals/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsJualData(true);
      // Data Register/Pembeli
      setNamaRegister(response.data.namaRegister);
      setNoKtpRegister(response.data.noKtpRegister);
      setKetBlacklist(response.data.ketBlacklist);
      setKetPencairan(response.data.ketPencairan);
      setIsAccHeadSurveyor(response.data.isAccHeadSurveyor);

      // Data Penjualan -> dari input
      setHargaTunai(response.data.hargaTunai);
      setUangMuka(response.data.uangMuka);
      setAngPerBulan(response.data.angPerBulan);
      setTenor(response.data.tenor);
      setSisaBulan(response.data.sisaBulan);
      setGambar(response.data.gambar);
      setGambarBerkas(
        response.data.gambarBerkas ? response.data.gambarBerkas : []
      );
      setIsPost(response.data.isPost);
    }
  };

  const updateJual = async (e) => {
    e.preventDefault();
    setLoading(true);

    let isFailedValidation = false;
    if (isFailedValidation) {
      setError(true);
      setOpen(!open);
    } else {
      try {
        await axios.post(`${tempUrl}/updateJual/${id}`, {
          ketPencairan,
          isAccHeadSurveyor,
          kodeCabang: user.cabang._id,
          id: user._id,
          token: user.token,
        });

        getJualById();
        handleCloseUbah(e);
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
    setValidated(true);
    setLoading(false);
  };

  const pilihCetakPdf = () => {
    if (pilihCetak === "daftarJual") {
      downloadPdfDaftarJual();
    }
  };

  const downloadPdfDaftarJual = async () => {
    setLoading(true);
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);

    const allJualsForTable = await axios.post(`${tempUrl}/jualsForTable`, {
      dariTgl: user.periode.periodeAwal,
      sampaiTgl: user.periode.periodeAkhir,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Jual`, 90, 30);
    doc.setFontSize(10);
    doc.text(`Periode: ${user.periode.namaPeriode}`, 15, 35);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.setFontSize(12);
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: allJualsForTable.data,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
    setLoading(false);
  };

  const downloadExcel = async () => {
    setLoading(true);
    let allJuals;
    if (user.tipeUser === "EKS") {
      allJuals = await axios.post(
        `${tempUrl}/jualsCustomerPerSurveyorKodeKolektor`,
        {
          status: value,
          statusAcc: valueAcc,
          kodeSurveyor: kodeSurveyorFilter.split(" -", 1)[0],
          kodeKolektor: user.kodeKolektor,
          dariTgl: user.periode.periodeAwal,
          sampaiTgl: user.periode.periodeAkhir,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );
    } else {
      allJuals = await axios.post(`${tempUrl}/jualsCustomerPerSurveyor`, {
        status: value,
        statusAcc: valueAcc,
        kodeSurveyor: kodeSurveyorFilter.split(" -", 1)[0],
        dariTgl: user.periode.periodeAwal,
        sampaiTgl: user.periode.periodeAkhir,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
    }

    const workSheet = XLSX.utils.json_to_sheet(allJuals.data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `Jual`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarJual.xlsx`);
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Penjualan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Customer Per Surveyor
      </Typography>
      <Box sx={showDataContainer}>
        <Box sx={showDataWrapper}>
          <FormControl sx={{ marginTop: 1 }}>
            <FormLabel id="demo-controlled-radio-buttons-group">
              Filter
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue="Semua"
              value={value}
              onChange={handleChangeFilter}
            >
              <FormControlLabel
                value="Aktif Saja"
                control={<Radio />}
                label="Aktif Saja"
              />
              <FormControlLabel
                value="Lunas"
                control={<Radio />}
                label="Lunas"
              />
              <FormControlLabel
                value="Penarikan"
                control={<Radio />}
                label="Tarik"
              />
              <FormControlLabel
                value="Semua"
                control={<Radio />}
                label="Semua"
              />
              <FormControlLabel
                value="keteranganBlm"
                control={<Radio />}
                label="Keterangan (Blm)"
              />
              <FormControlLabel
                value="keteranganOk"
                control={<Radio />}
                label="Keterangan (OK)"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
      <Box sx={showDataContainerSecond}>
        <Box sx={showDataWrapper}>
          <FormControl sx={{ marginTop: 1 }}>
            <FormLabel id="demo-controlled-radio-buttons-group">
              Filter Acc
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue="Semua"
              value={valueAcc}
              onChange={handleChangeFilterAcc}
            >
              <FormControlLabel
                value="Semua"
                control={<Radio />}
                label="Semua"
              />
              <FormControlLabel value="Acc" control={<Radio />} label="Acc" />
              <FormControlLabel
                value="BlmAcc"
                control={<Radio />}
                label="Blm Acc"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
      <Box sx={showDataContainer}>
        <Box sx={showDataWrapper}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kode Surveyor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    disabled={user.tipeUser === "SUR" ? true : false}
                    options={surveyorOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        placeholder="SEMUA SURVEYOR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      let tempValue;
                      if (value === null) {
                        console.log("Value null");
                        tempValue = "";
                      } else {
                        tempValue = value.label;
                      }
                      setKodeSurveyorFilter(tempValue);
                    }}
                    value={kodeSurveyorFilter}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Total Konsumen :
                </Form.Label>
                <Col sm="8">
                  <Form.Control value={rows.toLocaleString("en-US")} disabled />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => {
                  console.log("In");
                  getJualsData();
                }}
              >
                CARI
              </Button>
            </Col>
          </Row>
          <Box sx={[showDataWrapper, secondWrapper]}></Box>
        </Box>
      </Box>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button startIcon={<PrintIcon />} onClick={() => pilihCetakPdf()}>
            CETAK
          </Button>
          <Button startIcon={<DownloadIcon />} onClick={() => downloadExcel()}>
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>

      <Divider sx={dividerStyle} />

      {/* {isJualExist && (
        <Box sx={buttonModifierContainer}>
          <Button
            color="primary"
            variant="contained"
            startIcon={<EditIcon />}
            sx={{ textTransform: "none" }}
            onClick={handleClickOpenUbah}
          >
            Ubah
          </Button>
        </Box>
      )} */}

      {isJualExist && isJualData && gambar.length !== 0 && (
        <Box sx={contentContainer}>
          {/* Gambar Data Unit */}
          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              Gambar Data Unit
            </Typography>
            <Carousel breakPoints={breakPoints} sx={carouselStyle}>
              {gambar.length !== 0 &&
                gambar.map((img, i) => (
                  <Card sx={carouselCard} elevation={10}>
                    <CardActionArea>
                      <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                      <CardMedia
                        component="img"
                        height="100%"
                        src={img}
                        alt={namaRegister}
                        sx={oldImageCardMedia}
                        onClick={() => {
                          window.open(img, "_blank", "noopener,noreferrer");
                        }}
                      />
                    </CardActionArea>
                  </Card>
                ))}
            </Carousel>
          </Paper>
        </Box>
      )}

      {isJualExist && isJualData && gambarBerkas.length !== 0 && (
        <Box sx={contentContainer}>
          {/* Gambar Berkas */}
          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              Gambar Berkas
            </Typography>
            <Carousel breakPoints={breakPoints} sx={carouselStyle}>
              {gambarBerkas.length !== 0 &&
                gambarBerkas.map((img, i) => (
                  <Card sx={carouselCard} elevation={10}>
                    <CardActionArea>
                      <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                      <CardMedia
                        component="img"
                        height="100%"
                        src={img}
                        alt={namaRegister}
                        sx={oldImageCardMedia}
                        onClick={() => {
                          window.open(img, "_blank", "noopener,noreferrer");
                        }}
                      />
                    </CardActionArea>
                  </Card>
                ))}
            </Carousel>
          </Paper>
        </Box>
      )}

      <Divider sx={dividerStyle} />
      {isJualExist && isJualData && (
        <>
          <Box sx={contentContainer}>
            <Box sx={{ marginBottom: "10px" }}>
              <Button
                variant="outlined"
                color="secondary"
                // onClick={() => navigate("/customerPerSurveyor")}
                onClick={() => setIsJualData(false)}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
            </Box>

            {/* Data */}
            <Paper elevation={6} sx={mainContainer}>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          No. KTP :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control value={noKtpRegister} disabled />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Ket. Black List :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control value={ketBlacklist} disabled />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  {user.tipeUser === "HEADSURVEYOR" ? (
                    <>
                      {isAccHeadSurveyor ? (
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="4" style={textRight}>
                                Ket. Pencairan :
                              </Form.Label>
                              <Col sm="8">
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  value={ketPencairan}
                                  disabled
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="4" style={textRight}>
                                Ket. Pencairan :
                              </Form.Label>
                              <Col sm="8">
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  value={ketPencairan}
                                  onChange={(e) => {
                                    setKetPencairan(
                                      e.target.value.toUpperCase()
                                    );
                                  }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col>
                          <Form.Group
                            as={Row}
                            className="mb-3"
                            controlId="formPlaintextPassword"
                          >
                            <Form.Label column sm="4" style={textRight}>
                              Acc. Head :
                            </Form.Label>
                            <Col sm="8">
                              <FormControlLabel
                                control={
                                  <Checkbox checked={isAccHeadSurveyor} />
                                }
                                disabled
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col>
                          <Form.Group
                            as={Row}
                            className="mb-3"
                            controlId="formPlaintextPassword"
                          >
                            <Form.Label column sm="4" style={textRight}>
                              Ket. Pencairan :
                            </Form.Label>
                            <Col sm="8">
                              <Form.Control
                                as="textarea"
                                rows={3}
                                value={ketPencairan}
                                disabled
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                      </Row>
                      {ketPencairan.length > 0 ? (
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="4" style={textRight}>
                                Acc. Head :
                              </Form.Label>
                              <Col sm="8">
                                <FormControlLabel
                                  control={
                                    <Checkbox checked={isAccHeadSurveyor} />
                                  }
                                  onChange={() =>
                                    setIsAccHeadSurveyor(!isAccHeadSurveyor)
                                  }
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                      ) : (
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="4" style={textRight}>
                                Acc. Head :
                              </Form.Label>
                              <Col sm="8">
                                <FormControlLabel
                                  control={
                                    <Checkbox checked={isAccHeadSurveyor} />
                                  }
                                  disabled
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Harga Tunai :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control
                            //type="number"
                            value={hargaTunai.toLocaleString("en-US")}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Uang Muka :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control
                            //type="number"
                            value={uangMuka.toLocaleString("en-US")}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Angsuran/Bulan :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control
                            //type="number"
                            value={angPerBulan.toLocaleString("en-US")}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Tenor :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control type="number" value={tenor} disabled />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="4" style={textRight}>
                          Sisa Bulan :
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control
                            type="number"
                            value={sisaBulan}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Box>
              </Box>

              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={updateJual}
              >
                Simpan
              </Button>
            </Paper>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableJualCustomerPerSurveyor
          currentPosts={jualsData}
          setIsJualData={setIsJualData}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilCustomerPerSurveyor;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataContainerSecond = {
  mt: 2,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  // maxWidth: {
  //   md: "40vw",
  // },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const pilihCetakContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: 2,
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "600",
};

const contentContainer = {
  p: {
    sm: 0,
    md: 3,
  },
  pt: {
    sm: 0,
    md: 1,
  },
  mt: {
    sm: 0,
    md: 2,
  },
};

const carouselStyle = {
  display: "flex",
  height: "200px",
};

const carouselCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "primary",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};

const colorRed = {
  color: "red",
};
